export default __webpack_public_path__ + "static/media/mobile-menu.c8a09b49.svg";